import { Autocomplete, Button, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Radio, RadioGroup, Select, TextareaAutosize, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import Required from '../utility/required';
import GlobalTextField from '../utility/globalTextfield';
// import globalStyles from "../../../assets/styles/global.module.scss";
import globalStyles from "../../assets/styles/global.module.scss";
import connectorstyle from '../../assets/styles/componentStyles/dataconnector.module.scss'
import styles from '../../assets/styles/componentStyles/dataconnectorform.module.scss'
import dataConnectorMainstyles from '../../assets/styles/componentStyles/dataconnector.module.scss'
import { Close } from '@mui/icons-material';
import { ChatbotContext, ChatbotContextPayload } from '../../context/chatbotContext';
import persistentMenuStyles from '../../assets/styles/componentStyles/persistentStyles/persistent.module.scss';
import { chatbotPersistentMenu } from '../../models/axiosModel';
import { parentPersistentMenuName } from '../dashboard/persistentMenu/persistentMenu';
import autoCompleteStyle from "../../assets/styles/componentStyles/whatsappCampaignStyles/whatsappCampaignStyle.module.scss";
import { chatbotListInterface, SubChatbot } from '../../models/axiosModel';
import { useSearchParams } from 'react-router-dom'; 
import contactStyles from "../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss"; 

interface PersistentMenuModalProps {
    setFlagOpenMenuItemDialog: React.Dispatch<React.SetStateAction<boolean>>, 

    handlePersistentMenuDetails: (field: string, value: string | number | undefined) => void,
    handleSavePersistentData: () => Promise<void>,

    requestPersistentMenuDetailsList: chatbotPersistentMenu,
    setRequestPersistentMenuDetailsList: React.Dispatch<React.SetStateAction<chatbotPersistentMenu>>, 

    flagKeyExistError: boolean, 
    setFlagKeyExistError: React.Dispatch<React.SetStateAction<boolean>>, 

    flagOpenSubMenuItemDialog: boolean, 
    setFlagOpenSubMenuItemDialog: React.Dispatch<React.SetStateAction<boolean>>,

    parentPersistentMenuName: parentPersistentMenuName, 

    selectedActionType: string, 
    setSelectedActionType: React.Dispatch<React.SetStateAction<string>>, 

    isActionTypeDisabled: () => boolean, 

    getStaticMessageFormatApiCall: (chatbot_id: string) => void,
}  

const PersistentMenuModal: React.FC<PersistentMenuModalProps> = (props) => {

    const {
        handlePersistentMenuDetails,
        requestPersistentMenuDetailsList,
        setRequestPersistentMenuDetailsList,
        handleSavePersistentData,
        setFlagOpenMenuItemDialog,
        flagKeyExistError,
        setFlagKeyExistError,

        flagOpenSubMenuItemDialog,
        setFlagOpenSubMenuItemDialog,

        parentPersistentMenuName,
        selectedActionType,
        setSelectedActionType,
        isActionTypeDisabled, 

        getStaticMessageFormatApiCall,
    } = props

    const getHandleSavePersistentDataDisable = () => {
        if (selectedActionType === "Text") {
            if (requestPersistentMenuDetailsList.chatbot_persistent_menu_name?.trim() !== "" && requestPersistentMenuDetailsList.chatbot_persistent_menu_name !== null &&
                requestPersistentMenuDetailsList.chatbot_persistent_menu_value?.trim() !== "" && requestPersistentMenuDetailsList.chatbot_persistent_menu_value !== null
            ) {
                return false;
            } else { return true; }
        }
        else if (selectedActionType === "Static Message") {
            if (requestPersistentMenuDetailsList.chatbot_persistent_menu_name?.trim() !== "" && requestPersistentMenuDetailsList.chatbot_persistent_menu_name !== null &&
                requestPersistentMenuDetailsList.static_message_id !== undefined && requestPersistentMenuDetailsList.static_message_id !== null
            ) {
                return false;
            } else {
                return true;
            }
        } else {
            if (requestPersistentMenuDetailsList.chatbot_persistent_menu_name?.trim() !== "" && requestPersistentMenuDetailsList.chatbot_persistent_menu_name !== null) {
                return false;
            } else return true;
        }
    }

    const { chatbotStaticMessageFormat, chatBotDetails } = useContext(ChatbotContext) as ChatbotContextPayload 
    const [searchParams, setSearchParams] = useSearchParams(); 
    const chatbot_id = searchParams.get('chatbot_id');

    useEffect(() => {
        if(requestPersistentMenuDetailsList.target_chatbot_id){
            getStaticMessageFormatApiCall(requestPersistentMenuDetailsList.target_chatbot_id);
        }else{
            getStaticMessageFormatApiCall(chatbot_id || "");
        }
    }, []);

    return (
        <>
            <Grid container >
                <Grid item xs={12}>
                    <Grid container className={persistentMenuStyles.popUpContainer}>
                        <Grid item className={persistentMenuStyles.textAlignCenter}>
                            <Typography className={contactStyles.popupTitleTypography}> {flagOpenSubMenuItemDialog ? `Add Sub Menu Item for ${parentPersistentMenuName.chatbot_persistent_menu_name}` : (!requestPersistentMenuDetailsList?.chatbot_persistent_menu_id) ? "Add Menu Item" : "Edit Menu Item"}</Typography>
                        </Grid>

                        <Divider className={contactStyles.popupTitleDivider} /> 

                        <Grid item>
                            <Grid container className={contactStyles.popupBodyGridContainer} gap={2}>

                                <Grid item xs={12}>
                                    <Grid container className={persistentMenuStyles.inputField}>
                                        <Grid item>
                                            <Typography className={persistentMenuStyles.popupFieldTypography}> Name <Required /></Typography>
                                        </Grid>
                                        <Grid item>
                                            <TextField
                                                placeholder='Enter New Key'
                                                value={requestPersistentMenuDetailsList?.chatbot_persistent_menu_name}
                                                onChange={(e) => {
                                                    setFlagKeyExistError(false)
                                                    handlePersistentMenuDetails('chatbot_persistent_menu_name', e.target.value)
                                                }}
                                                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`} 
                                            />
                                        </Grid>
                                        {flagKeyExistError &&
                                            <span className={globalStyles.validationText}>
                                                This Menu Name already exist!
                                            </span>
                                        }
                                    </Grid>
                                </Grid> 

                                <Grid item xs={12}>
                                    <Grid container className={persistentMenuStyles.inputField}>
                                        <Grid item>
                                            <Typography className={persistentMenuStyles.popupFieldTypography}> Select Sub Chatbot </Typography>
                                        </Grid>
                                        <Grid item>
                                            <Autocomplete
                                                className={`${autoCompleteStyle.whatsappCampaignDropDowns} ${persistentMenuStyles.autoComplete}`}
                                                options={chatBotDetails ? chatBotDetails.sub_chatbot : []} 
                                                value={chatBotDetails ? chatBotDetails.sub_chatbot.find((chatbot: SubChatbot) => String(chatbot.chatbot_id) == requestPersistentMenuDetailsList?.target_chatbot_id) : null} 
                                                getOptionLabel={(option) => option ? option.chatbot_name : ""} 
                                                renderInput={(params) => <TextField {...params} placeholder="Select Sub Chatbot" />}
                                                onChange={(_, value: SubChatbot | null) => {
                                                    handlePersistentMenuDetails('target_chatbot_id', value ? value.chatbot_id : undefined)
                                                }} 
                                                disabled={selectedActionType == "None"}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Grid container className={persistentMenuStyles.inputField}>
                                        <Grid item>
                                            <Typography className={persistentMenuStyles.popupFieldTypography}>Action Type <Required /></Typography>
                                        </Grid>
                                        <Grid item>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                name="radio-buttons-group"
                                                value={selectedActionType}
                                                className={persistentMenuStyles.actionTypeRadioButton}
                                            >
                                                <FormControlLabel value="Text" control={<Radio color='secondary' />} disabled={isActionTypeDisabled()} label="Text" onChange={(e) => { setSelectedActionType("Text"); }} />
                                                <FormControlLabel value="Static Message" control={<Radio color='secondary' />} disabled={isActionTypeDisabled()} label="Static Message" onChange={(e) => { setSelectedActionType("Static Message"); }} />
                                                <FormControlLabel value="None" control={<Radio color='secondary' />} label="None" disabled={(requestPersistentMenuDetailsList?.target_chatbot_id != null && requestPersistentMenuDetailsList?.target_chatbot_id != chatbot_id)} onChange={(e) => { setSelectedActionType("None"); }} />
                                            </RadioGroup>
                                        </Grid>
                                    </Grid>
                                </Grid> 

                                {selectedActionType != "None" &&
                                    <Grid item xs={12}>
                                        <Grid container className={persistentMenuStyles.inputField}>
                                            <Grid item>
                                                <Typography className={persistentMenuStyles.popupFieldTypography}>{selectedActionType} <Required /></Typography>
                                            </Grid>
                                            <Grid item>
                                                {selectedActionType === "Text" ?
                                                    <>
                                                        <textarea
                                                            rows={3}
                                                            placeholder='Enter Value'
                                                            className={persistentMenuStyles.textTextArea}
                                                            value={requestPersistentMenuDetailsList.chatbot_persistent_menu_value}
                                                            onChange={(e) => {
                                                                handlePersistentMenuDetails('chatbot_persistent_menu_value', e.target.value)
                                                            }}
                                                        />
                                                    </>
                                                    :
                                                    <>
                                                        <Autocomplete
                                                            options={chatbotStaticMessageFormat}
                                                            getOptionLabel={(option) => option.chatbot_static_message_name}
                                                            value={chatbotStaticMessageFormat.find((format) => format.chatbot_static_message_id == requestPersistentMenuDetailsList.static_message_id) || null}
                                                            className={`${autoCompleteStyle.whatsappCampaignDropDowns} ${persistentMenuStyles.autoComplete}`} 
                                                            onChange={(event, newValue) => { handlePersistentMenuDetails('static_message_id', newValue?.chatbot_static_message_id) }}
                                                            renderInput={(params) => <TextField {...params} placeholder="Select Static Message" />}
                                                        />
                                                    </>
                                                }
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }


                            </Grid>
                        </Grid> 

                        <Grid item>
                            <Grid container className={persistentMenuStyles.popupBtnsContainer}>
                                <Grid item>
                                    <Button
                                        variant="outlined"
                                        size="medium"
                                        fullWidth
                                        className={dataConnectorMainstyles.cbCancelButton}
                                        onClick={() => {
                                            setFlagOpenMenuItemDialog(false);
                                            setFlagOpenSubMenuItemDialog(false);
                                            setFlagKeyExistError(false);
                                            setRequestPersistentMenuDetailsList({
                                                ...requestPersistentMenuDetailsList,
                                                chatbot_persistent_menu_id: 0,
                                                chatbot_persistent_menu_name: "",
                                                chatbot_persistent_menu_value: "", 
                                                target_chatbot_name: "-",
                                                target_chatbot_id: undefined,
                                                static_message_id: undefined, 
                                                chatbot_static_message_name: "-",
                                                parent_chatbot_persistent_menu_id: undefined,
                                            });
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button
                                        variant="contained"
                                        size="medium"
                                        fullWidth
                                        className={dataConnectorMainstyles.cbSaveButton}
                                        onClick={() => { handleSavePersistentData() }}
                                        disabled={getHandleSavePersistentDataDisable()}
                                        sx={{ opacity: getHandleSavePersistentDataDisable() ? "0.5" : "" }}
                                    >
                                        {`${requestPersistentMenuDetailsList?.chatbot_persistent_menu_id ? 'Save' : 'Create'}`}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        </>
    )
}

export default PersistentMenuModal